import { useCallback } from 'react';
import { Status } from '@wix/ambassador-genie-chat-service-v1-no-entity/types';
import { useParseMessageResponse } from './useParseMessageResponse';
const config = {
  pollInterval: 1000,
  maxPollAttempts: 5 * 60
};
const shouldStartPolling = (rawResponse, assistantMessage) => {
  return Boolean(rawResponse && assistantMessage && assistantMessage.status === Status.STATUS_PENDING);
};
const pollForMessage = async (messageId, getMessage, options) => {
  const {
    pollInterval,
    maxPollAttempts
  } = options;
  for (let attempt = 0; attempt < maxPollAttempts; attempt++) {
    await new Promise(resolve => setTimeout(resolve, pollInterval));
    try {
      const polledMessage = await getMessage(messageId);
      if (polledMessage && polledMessage.status === Status.STATUS_COMPLETED) {
        return polledMessage;
      }
    } catch (error) {
      console.warn(`Polling attempt ${attempt + 1} failed:`, error);
      throw error;
    }
  }
  return null;
};
export function useMessagePolling(sendMessage, getMessage) {
  const parseMessageResponse = useParseMessageResponse();
  return useCallback(async function () {
    var _rawResponse$assistan;
    const {
      messageResponse,
      rawResponse
    } = await sendMessage(...arguments);
    if ('functionCall' in messageResponse) {
      return {
        messageResponse,
        rawResponse
      };
    }
    const lastAssistantMessage = rawResponse == null || (_rawResponse$assistan = rawResponse.assistantMessages) == null || (_rawResponse$assistan = _rawResponse$assistan.slice(-1)) == null ? void 0 : _rawResponse$assistan[0];
    const messageIdToPoll = lastAssistantMessage == null ? void 0 : lastAssistantMessage.id;
    if (!messageIdToPoll || !shouldStartPolling(rawResponse, lastAssistantMessage)) {
      return {
        messageResponse,
        rawResponse
      };
    }
    const polledMessage = await pollForMessage(messageIdToPoll, getMessage, config);
    if (!rawResponse || !polledMessage) {
      return {
        messageResponse,
        rawResponse
      };
    }
    const polledResponse = {
      assistantMessages: [polledMessage],
      agentName: rawResponse.agentName,
      functionCalls: rawResponse.functionCalls,
      logs: rawResponse.logs,
      requestId: rawResponse.requestId
    };
    return {
      messageResponse: parseMessageResponse(polledResponse),
      rawResponse
    };
  }, [getMessage, parseMessageResponse, sendMessage]);
}
//# sourceMappingURL=useMessagePolling.js.map